export const GROUP_TYPES = Object.freeze({
  ORGANIZATION: 'organization',
  TEAM: 'team',
  SYSTEM: 'system'
});

export const GROUP_TYPE_OPTIONS = [
  { value: GROUP_TYPES.ORGANIZATION, label: 'Organization' },
  { value: GROUP_TYPES.TEAM, label: 'Team' },
  { value: GROUP_TYPES.SYSTEM, label: 'System' }
];

/** Page configuration.view for Groups page */
export const GROUPS_PAGE_VIEWS = Object.freeze({
  ORGANIZATION: 'organization',
  TEAM: 'team'
});

export const GP_HIERARCHY_RELATIONSHIP_TYPE = 'team_nested';

/**
 * team_nested relationships.metadata — Groups team view access.
 * When true on the link for a team period the user belongs to, they see all teams under that org.
 * Not required for System / Super Admin — those roles always see the full org tree on My Groups.
 */
export const TEAM_NESTED_META_SEE_ALL_ORG_CHILDREN = 'see_all_org_children';

/**
 * team_nested relationships.metadata — peer visibility at the enrolled team's depth.
 * User sees all sibling teams under the same parent (same level), plus every descendant
 * of those siblings. Ancestors and cousins above that level are hidden.
 */
export const TEAM_NESTED_META_SEE_ALL_SAME_LEVEL_CHILDREN = 'see_all_same_level_children';

export function parseRelationshipMetadata(raw) {
  if (raw == null) return {};
  if (typeof raw === 'object' && !Array.isArray(raw)) return raw;
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return typeof parsed === 'object' && parsed ? parsed : {};
    } catch {
      return {};
    }
  }
  return {};
}

export function teamNestedSeeAllOrgChildren(metadata) {
  return parseRelationshipMetadata(metadata)[TEAM_NESTED_META_SEE_ALL_ORG_CHILDREN] === true;
}

export function teamNestedSeeAllSameLevelChildren(metadata) {
  return parseRelationshipMetadata(metadata)[TEAM_NESTED_META_SEE_ALL_SAME_LEVEL_CHILDREN] === true;
}

/**
 * API sets relationships.superparent_id on team_nested rows (root org groups_periods id).
 * Use for org-wide queries — see api/constants/groupHierarchy.js SUPERPARENT_ID_GUIDE.
 */
export const SUPERPARENT_ID_API_NOTE =
  'Org-scoped team queries: filter relationships.superparent_id = org groups_periods id';
